module.exports = __webpack_public_path__ + "media/src/components/InsuranceProduct/health-insurance-0947494479c7c11d54ec01794445ba47.png";